import React, { useCallback, useEffect } from 'react';

import { twMerge } from 'tailwind-merge';

import { Form, Formik } from 'formik';

import { TbX } from 'react-icons/tb';

import Typography from 'components-new/typography/typography';
import { showErrorToast, showSuccessToast } from 'components-new/toast/toast';
import Divider from 'components-new/divider/divider';
import Icon from 'components-new/icon/icon';
import Button from 'components-new/button/button';

import Dialog from 'components/dialog/dialog';

import DateInputField from 'form-elements/date-input-field';

import { createLocale } from 'locales';

import useRequestContracts from 'state/remote/remote-organization/use-request-contracts';

import type { ContractRequest } from 'state/__generated__/tadaahAPI';

const globalLocalize = createLocale('global');
const weekplannerLocalize = createLocale('organizationWeekPlannerLocales');

interface ContractsExportDialogDialogProps {
  isOpen?: boolean;
  onCloseClicked: () => void;
}
const ContractsExportDialog: React.FC<ContractsExportDialogDialogProps> = (
  props,
) => {
  const { isOpen, onCloseClicked } = props;

  const { initialValues, error, isSuccess, isLoading, requestContracts } =
    useRequestContracts();

  const closeButtonClassNames = twMerge(
    'absolute right-4 p-2 rounded-md',
    'hover:bg-gray100',
    'transition ease-in-out duration-300',
  );

  const submitRequest = useCallback(
    (values: ContractRequest) => {
      requestContracts(values);
      onCloseClicked();
    },
    [requestContracts, onCloseClicked],
  );

  useEffect(() => {
    if (error) {
      showErrorToast({ description: error, title: globalLocalize('error') });
    }

    if (isSuccess)
      showSuccessToast({
        description: weekplannerLocalize('contractRequestSuccess'),
        title: 'Succes',
      });
  }, [isSuccess, error]);

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onCloseClicked}
      className="max-w-[90%] max-h-[60%] mt-6 lg:w-[700px] lg:max-w-[60%] z-40"
    >
      <div
        id="header"
        className="relative flex justify-between items-center px-8 py-4 "
      >
        <Typography
          variant="heading-2"
          as="p"
          className="text-gray800 max-w-[90%]"
        >
          {weekplannerLocalize('contractsExport')}
        </Typography>
        <button
          type="button"
          className={closeButtonClassNames}
          onClick={onCloseClicked}
        >
          <Icon icon={TbX} />
        </button>
      </div>
      <Divider orientation="horizontal" className="w-full" />
      <div className="p-4 overflow-scroll">
        <Formik initialValues={initialValues} onSubmit={submitRequest}>
          <Form className="w-full">
            <Typography
              as="p"
              variant="body-large-bold"
              className="my-3 flex justify-start items-center text-red"
            >
              {weekplannerLocalize('contractRequestMsg')}
            </Typography>
            <Typography
              as="h3"
              variant="body-large-bold"
              className="text-gray600 mt-6 flex w-full justify-start items-center"
            >
              {weekplannerLocalize('startDate')}
            </Typography>
            <DateInputField
              name="from_date"
              inputClassName="pl-12"
              placeholder="from date"
            />
            <Typography
              as="h3"
              variant="body-large-bold"
              className="text-gray600 mt-6 flex w-full justify-start items-center"
            >
              {weekplannerLocalize('endDate')}
            </Typography>
            <DateInputField
              name="to_date"
              inputClassName="pl-12"
              placeholder="from date"
            />
            <div className="flex justify-between items-center mt-10">
              <Button
                variant="secondary"
                type="button"
                label={globalLocalize('goBack')}
                onClick={onCloseClicked}
              />
              <Button
                variant="primary"
                loading={isLoading}
                label={weekplannerLocalize('requestContracts')}
                type="submit"
              />
            </div>
          </Form>
        </Formik>
      </div>
    </Dialog>
  );
};

export default ContractsExportDialog;
